export default __webpack_public_path__ + "static/media/other.0e8f98b1.svg";